import {
    INIT_REGISTRATION_FORM,
    SAVE_REGISTRATION_DATA,
    SEND_REGISTRATION_DATA,
    GET_REGISTRATION_SUCCESS,
    HANDLE_INVALID_API_RESPONSE,
    TRACK_REGISTRATION_CHECK,
    READ_SESSION_STORAGE,
} from './constant';
import { addTrackingToAction } from '@vfde-sails/tracking';
import { successNotificationTracking, initTracking } from './tracking';
import { IHouseAddressData } from './interface';

/**
 * Export initRegistrationForm
 *
 * @export initRegistrationForm
 */
export const initRegistrationForm = () => {
    return {
        type: INIT_REGISTRATION_FORM,
    };
};

/**
 * Export readSessionStorage
 *
 * @export readSessionStorage
 */
export const readSessionStorage = (addressData: IHouseAddressData) => {
    return {
        type: READ_SESSION_STORAGE,
        addressData,
    };
};

/**
 * Export saveRegistrationData
 *
 * @export saveRegistrationData
 */
export const saveRegistrationData = (update) => {
    return {
        type: SAVE_REGISTRATION_DATA,
        update,
    };
};

/**
 * Export sendRegistrationData
 *
 * @export sendRegistrationData
 */
export const sendRegistrationData = () => {
    return {
        type: SEND_REGISTRATION_DATA,
    };
};

/**
 * Export getRegistrationSuccess
 *
 * @export getRegistrationSuccess
 */
export const getRegistrationSuccess = (responseData) => {
    return {
        type: GET_REGISTRATION_SUCCESS,
        responseData,
    };
};

/**
 * Export handleInvalidApiResponse
 *
 * @export handleInvalidApiResponse
 */
export const handleInvalidApiResponse = () => {
    return {
        type: HANDLE_INVALID_API_RESPONSE,
    };
};

/**
 * Track the form
 */
const trackForm = (payload: any) => {
    return addTrackingToAction(
        {
            type: TRACK_REGISTRATION_CHECK,
        },
        'pageview',
        payload,
    );
};

/**
 * trackInitialPageView
 */
export const trackInitialPageView = (siteStructure: string[], loginStatus: string) => {
    const trackingPayload = initTracking(siteStructure, loginStatus);

    return trackForm (trackingPayload);
};

/**
 * track address found
 */
export const trackRegistrationSuccess = (siteStructure: string[], loginStatus: string) => {
    const trackingPayload = successNotificationTracking(siteStructure, loginStatus);

    return trackForm (trackingPayload);
};
